// remove the super annoying aria-label from inside flickity sliders which are inherently broken in terms of accessibility. The containers are labeled "aria-hidden=true" but its descendants have aria-properties which is absolutely mind-boggling to me.




 window.addEventListener('load', function() {
 // console.log('inside hide aria-label!')
  document.querySelectorAll('.flickityt4s-slider > .brand_item > .db').forEach(function(element) {
    element.removeAttribute('aria-label');
  });
  // do the same thing for the featured products section
   document.querySelectorAll('.pa > .db').forEach(function(element) {
    // console.log(element);
    element.removeAttribute('aria-label');
    // console.log("removed aria label!");
  });
 });

 // window.addEventListener('DOMContentLoaded', function() {
 //     console.log('inside hide aria-label!')
 //  document.querySelectorAll('.brand-item > .db').forEach(function(element) {
 //    console.log(element);
 //    element.removeAttribute('aria-label');
 //  });
 // });

jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });

});


// 6.19.2024
// KB adding in custom js for BazaarVoice app
// When user hovers on "Read Reviews" on a product page, this script will make the Reviews tab active and show the reviews tab, while also un-activating the default active tab "Description"

// console.log("BV HOVER JAWN CODE REPORTING IN")


// setTimeout(function(){

//   const bv_ratings_hover_jawn = document.querySelector("#shopify-section-pr_summary > div:nth-child(2) > .bv_main_container > button");
//   console.log(bv_ratings_hover_jawn);
//   bv_ratings_hover_jawn.addEventListener(("mouseover", event => {
//     console.log('MOUSED OVERRRRRR!!');
//   }))
  
// }, 1000);

// function alsoHideReviewsWidget(){
//   // this is super weird but bazaar voice is terrible and we cant figure out where this snippet for the reviews app is even coming from so we're just going to display:none it after a second (since the piece is generated via a script)
//   const reviewsComponentToHide = document.querySelector("#bv_review_maincontainer > div.bv-rnr__sc-16dr7i1-0.bv-rnr__sc-10ra6n1-1.coRjPr > div.bv-rnr__di1qf-0.fstbtp");
//   console.log(reviewsComponentToHide)
//   reviewsComponentToHide.style.display = "none";
// }





function bv_show_reviews() {

  const bv_ratings_hover_jawn = document.querySelector(".bv_ratings_summary");
  // const bv_ratings_hover_jawn = document.querySelector("#shopify-section-pr_summary > div:nth-child(2) > .bv_main_container > button");
  // console.log("HAMBURGER", bv_ratings_hover_jawn);
 bv_ratings_hover_jawn.addEventListener(
  "mouseover",
  (event) => {
    // remove active class from "Description" tab
    const description_tab = document.querySelector("#wrap_des_pr > div > ul > li:first-child");
    description_tab.classList.remove("active");
    
    // console.log("INSIDE OF MOUSEOVER");
    const ratings_tab = document.querySelector("#wrap_des_pr > div > ul > li:last-child");
    // give ratings_tab class of "active"
    ratings_tab.classList.add("active");
    // show reviews widget
    const ratings = document.getElementById("tab_rivui");
    // console.log('sdsdhasd', ratings);
    ratings.style.display = "block";
    
    // alsoHideReviewsWidget();
  },
  true,
);
}

setTimeout(() => {
  bv_show_reviews();
}, 1500);


function make_text_white_steel_page(){
  const textNodes = document.querySelectorAll(".overlay-bottom > p")

  textNodes.forEach((node) => {
    node.style.color = "white";
  })
}



// 10-31-2024 amai sale badge not showing fix below
function show_sales_badge() {

  // can we make this target any collections page?
  if (window.location.href === "https://www.zebrapen.com/collections/gratitude-month") {
      // const all_collection_prod = document.querySelectorAll(".shg-product > .shg-c > .shg-product-image-wrapper")
    const all_collection_prod = document.getElementsByClassName("shg-product-image-wrapper")
      

      for (let index = 0; index < all_collection_prod.length; index++) {
        const new_span_to_append = document.createElement('div')
        new_span_to_append.innerHTML = `<span class="tc nt_labels pa pe_none cw"><span class="nt_label onsale">Sale</span></span>`
        all_collection_prod[index].appendChild(new_span_to_append.cloneNode(true))
      }

    
      // all_collection_prod.appendChild(new_span_to_append)
    //   console.log("all collection prod", all_collection_prod)
    // console.log("You are on the specific page!");
  }

  // const all_collections_page_items = 
}

setTimeout(() => {
  show_sales_badge();
  make_text_white_steel_page();
}, 1000);

// steel 2025 page

 window.addEventListener('load', function() {
  const currentUrl = window.location.href;
  // Check if the URL contains "/pages/steel-2025"
  const containsSteelPath = currentUrl.includes("/pages/steel-2025");
  
  if(containsSteelPath){

    // collect all column1's
    const columns = document.querySelectorAll(".column1");
    const centeredText = document.querySelectorAll(".centered-text");

    columns.forEach((element, idx) => {
    // Add mouseenter (hover) event listener
      
      element.addEventListener('mouseenter', function() {
        const child = element.querySelector(".centered-text");

        const overlayBox = element.querySelector(".overlay-text");
        overlayBox.classList.add("full-scale")
        
        child.style.backgroundColor = 'transparent';
      // Add your class when hovering
        child.classList.add("bring-forward");
        child.classList.add("slide-up-3-em");

    });
  
    // Optional: Remove the class when mouse leaves
    element.addEventListener('mouseleave', function() {
      const child = element.querySelector(".centered-text");
      const childClassList = child.classList;

      // overlay style
        const overlayBox = element.querySelector(".overlay-text");
        overlayBox.classList.remove("full-scale")
      
      childClassList.toggle("slide-up-3-em");
      childClassList.remove("full-scale")
      // childClassList.remove("hide-me-pls");

      //need to check and see what box is being hovered, background color depends on it
        // console.log(childClassList);
      if(childClassList.contains("steel-page-gray")){
          child.style.backgroundColor = "#777777";
        } else if(childClassList.contains("steel-page-green")){
          child.style.backgroundColor = "#828c68";
        } else if(childClassList.contains("steel-page-tan")){
          child.style.backgroundColor = "#d1c19c";
        } else if(childClassList.contains("steel-page-brown")){
          child.style.backgroundColor = " #7d4e35";
        }
  });
  

}); // end of columns.forEach

    // start of interactive filter
    const pens = document.querySelectorAll(".pen");

    pens.forEach((pen) => {
      pen.addEventListener("mouseover", () => {
        resetSwatches();
        movePenInward(pen);
        const swatchChild = pen.querySelector(".swatch");
        const swatchClassList = swatchChild.classList;
        swatchClassList.toggle("show-me");
      });
    });

    function movePenInward(penBeingHoveredOn){
      const penClassList = penBeingHoveredOn.classList;

        // if its a pen on the right side, put a margin-right class on it
      if(penClassList.contains("left-pen")){
        penBeingHoveredOn.classList.toggle("move-me-right");
      } else {
        // if its a pen on the left side, put a margin-left on it
        penBeingHoveredOn.classList.toggle("move-me-left");
      }


      // also need a function that removes the class on mouseout
    }

    function resetSwatches() {
      const pens = document.querySelectorAll(".pen");

      pens.forEach((pen) => {
        const swatchChild = pen.querySelector(".swatch");
        const swatchClassList = swatchChild.classList;
        if (swatchClassList.contains("show-me")) {
          swatchClassList.toggle("show-me");
        }

        // remove the "move-me-left and/or move-me-right classes"
        if(pen.classList.contains("move-me-left")){
          pen.classList.toggle("move-me-left")
        } else if(pen.classList.contains("move-me-right")) {
          pen.classList.toggle("move-me-right")
        }
      });
    }
    //   end of swatch toggle logic

    //   start of filter logic
    const filterButtons = document.querySelectorAll(".filter-btn");
    const mobileFilterButtons = document.querySelectorAll(".filter-button-mobile");

     mobileFilterButtons.forEach((button) => {
      button.addEventListener("click", function () {
        // reset other button colors
        resetButtonBackgrounds();
        hideAndShowSeriesMobile(button.classList);
        button.style.color = "black"; // this had to be done to overwrite userway's wonderful forced style changes

        button.classList.toggle("selected");

      });
    });

    filterButtons.forEach((button) => {
      button.addEventListener("click", function () {
        // reset other button colors
        resetButtonBackgrounds();
        hideAndShowSeries(button.classList);
        button.style.color = "black"; // this had to be done to overwrite userway's wonderful forced style changes

        button.classList.toggle("selected");
      });
    });

    //   reset other button backgrounds
    function resetButtonBackgrounds() {
      filterButtons.forEach((button) => {
        button.style.background = "transparent"; // this had to be done to overwrite userway's wonderful forced style changes
        if (button.classList.contains("selected")) {
          button.classList.toggle("selected");
        }
      });

      mobileFilterButtons.forEach((button) => {
        button.style.background = "transparent"; // this had to be done to overwrite userway's wonderful forced style changes
        if (button.classList.contains("selected")) {
          button.classList.toggle("selected");
        }
      });
    } /* end of resetButtonBackgrounds */

    function hideAndShowSeriesMobile(mobileClassList){
      console.log(mobileClassList)
           if (mobileClassList.contains("series-3-filter")) {
        // alert("3")
        hideOtherPenContainers(5)
      } else if (mobileClassList.contains("series-4-filter")) {
        // alert("4")
        hideOtherPenContainers(6)
      } else if (mobileClassList.contains("series-7-filter")) {
        // alert("7")
        hideOtherPenContainers(7)
      } else if(mobileClassList.contains("marker-fountain-filter")){
        hideOtherPenContainers(8)
      } else if(mobileClassList.contains("fountain-filter")){
        hideOtherPenContainers(9)
      }
    }

    function hideAndShowSeries(classList) {
      // const allPens = document.querySelector(".all-pens-filter");
      const series3 = document.querySelector(".series-3-pens-filter");
      const series4 = document.querySelector(".series-4-pens-filter");
      const series7 = document.querySelector(".series-7-pens-filter");
      const marker = document.querySelector(".marker-fountain-filter");
      const fountain = document.querySelector(".fountain-filter");
      // console.log(classList)

     if (classList.contains("series-3-filter")) {
        // alert("3")
        hideOtherPenContainers(0)
      } else if (classList.contains("series-4-filter")) {
        // alert("4")
        hideOtherPenContainers(1)
      } else if (classList.contains("series-7-filter")) {
        // alert("7")
        hideOtherPenContainers(2)
      } else if (classList.contains("marker-filter")){
       hideOtherPenContainers(3)
      } else if (classList.contains("fountain-filter")){
       hideOtherPenContainers(4)
      }
    } /* end of hideAndShowSeries() */

    function hideOtherPenContainers(index) {
      const allPenRowsContainers = document.querySelectorAll(
        ".pen-rows-container"
      );
      console.log('all pen rows containers ', allPenRowsContainers)

      allPenRowsContainers.forEach((container, idx) => {
        /* hide all rows except for the passed index value */
        if (idx != index) {
         if(!container.classList.contains("hide-me")){
          container.classList.add("hide-me");
         }
        } else {
          container.classList.remove("hide-me")
        }
      });
    } // end of filter container components
    
  } // end of "if(containsSteelPath)"

 });




